import GroupTypeService from '../../service/groupType';

const Action = {
    GET_GROUP_TYPE: "GET_GROUP_TYPE",
    GET_GROUP_TYPES: "GET_GROUP_TYPES",
};

const ActionCreator = {
    getGroupType(missionTypeId) {
        return async (dispatch) => {
            try {
                const groupType = await GroupTypeService.findById(missionTypeId);
                dispatch({type: Action.GET_GROUP_TYPE, groupType});
                return groupType;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getGroupTypes() {
        return async (dispatch) => {
            try {
                const groupTypes = await GroupTypeService.list();

                // 將 groupType 限制成 個人 . 企業 . 家庭
                const result = groupTypes.map((groupType) => {
                    if (groupType.label === 'person' || groupType.label === 'family' || groupType.label === 'company') {
                        return {...groupType, is_show: true};
                    } else {
                        return {...groupType, is_show: false};
                    }
                }).filter((groupType) => {
                    return (groupType.is_show === true);
                });

                dispatch({type: Action.GET_GROUP_TYPES, groupTypes: result});
                return result;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    list: [],
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_GROUP_TYPE:
            return {
                ...state,
                ...action.groupType
            };
        case Action.GET_GROUP_TYPES:
            return {
                ...state,
                list: action.groupTypes
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/groupType.js